/* eslint-disable */
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Paper,
  Fab,
  Tooltip,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import PublishedWithChangesOutlinedIcon from "@mui/icons-material/PublishedWithChangesOutlined";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { DatePicker } from "@mui/x-date-pickers";
import { useState, useEffect, useContext } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { Box } from "@mui/system";
import BuscarClienteDialog from "./BuscarClienteDialog";
import CambiarDocumentoDialog from "./CambiarDocumentoDialog";
import Message from "../../../project/utils/Message";
import { isPositiveInteger, getAge } from "../../../project/utils/utils";
import { getClienteByDocument } from "../../../project/services/ClienteService";
import { getCacheData } from "../../services/CacheService";
import { parse } from 'date-fns';
import WaitingDialog from "../../utils/WaitingDialog";
//
// ################################################################################
//
const Cliente = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [openDialogCambiarDocumento, setOpenDialogCambiarDocumento] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [paises, setPaises] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [ocupaciones, setOcupaciones] = useState([]);

  const {
    isSetClient,
    setIsSetClient,
    isNewClient,
    setIsNewClient,
    cliente,
    handleChangeCliente,
    handleChangeClienteFechaNacimiento,
    setCliente,
    limpiaGA,
    disabledCliente,
    gaAction,
  } = useContext(GestionAtencionContext);

  let {
    id,
    tipoDocumento,
    numeroDocumento,
    numeroCuitCuil,
    nombre,
    apellido,
    genero,
    fechaNacimiento,
    edadActual,
    eMail,
    telefonoMovil,
    telefonoFijo,
    domicilio,
    localidad,
    departamento,
    provincia,
    pais,
    codigoPostal,
    actividad,
    otraActividad,
    ocupacion,
    otraOcupacion,
  } = cliente;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTiposDocumentos();
    loadGeneros();
    loadDepartamentos();
    loadProvincias();
    loadPaises();
    loadActividades();
    loadOcupaciones();
  }, []);
  //
  // ################################################################################
  //
  const loadTiposDocumentos = async () => {
    const response = await getCacheData("tipo_documento")
    if (response.ok) {
      setTiposDocumentos(response.data.data);
      if (gaAction.cu === "new") {
        const _predeterminado = response.data.data.find(item => item.predeterminado)?.id ?? "";
        if (_predeterminado) {
          handleChangeCliente({
            target: {
              name: "tipoDocumento",
              value: _predeterminado,
              type: "text",
            },
          });
        }
      }
    } else {
      setTiposDocumentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadGeneros = async () => {
    const response = await getCacheData("genero")
    if (response.ok) {
      setGeneros(response.data.data);
    } else {
      setGeneros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadDepartamentos = async () => {
    const response = await getCacheData("departamento")
    if (response.ok) {
      setDepartamentos(response.data.data);
      if (gaAction.cu === "new") {
        const predeterminado = response.data.data.find((item) => item.predeterminado)?.id ?? "";
        if (predeterminado) {
          handleChangeCliente({
            target: {
              name: "departamento",
              value: predeterminado,
              type: "text",
            },
          });
        }
      }
    } else {
      setDepartamentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProvincias = async () => {
    const response = await getCacheData("provincia")
    if (response.ok) {
      setProvincias(response.data.data);
      if (gaAction.cu === "new") {
        const predeterminado = response.data.data.find((item) => item.predeterminado)?.id ?? "";
        if (predeterminado) {
          handleChangeCliente({
            target: {
              name: "provincia",
              value: predeterminado,
              type: "text",
            },
          });
        }
      }
    } else {
      setProvincias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadPaises = async () => {
    const response = await getCacheData("pais")
    if (response.ok) {
      setPaises(response.data.data);
      if (gaAction.cu === "new") {
        const predeterminado = response.data.data.find((item) => item.predeterminado)?.id ?? "";
        if (predeterminado) {
          handleChangeCliente({
            target: {
              name: "pais",
              value: predeterminado,
              type: "text",
            },
          });
        }
      }
    } else {
      setPaises([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadActividades = async () => {
    const response = await getCacheData("actividad")
    if (response.ok) {
      setActividades(response.data.data);
    } else {
      setActividades([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadOcupaciones = async () => {
    const response = await getCacheData("ocupacion")
    if (response.ok) {
      setOcupaciones(response.data.data);
    } else {
      setOcupaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const buscarCliente = () => {

    if (!tipoDocumento && !numeroDocumento) {
      return;
    }

    if (tipoDocumento === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el tipo de documento del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (!isPositiveInteger(numeroDocumento) || numeroDocumento.length < 7) {
      setMessage({
        severity: "error",
        messageText: "El documento del Cliente debe ser un número de 7 o más dígitos",
      });
      setShowMessage(true);
      return;
    }

    const loadCliente = async () => {
      let _params = {
        tipoDocumento,
        numeroDocumento,
      };

      setIsDoingSomething(true);
      const response = await getClienteByDocument(_params);
      setIsDoingSomething(false);

      if (response.ok) {
        if (response.exist) {
          // si existe el cliente

          const _cliente = {
            id: response.data.data.id,
            tipoDocumento: response.data.data.id_tipo_documento,
            numeroDocumento: response.data.data.num_doc,
            numeroCuitCuil: response.data.data.cuit_cuil,
            nombre: response.data.data.nombre ? response.data.data.nombre : "",
            apellido: response.data.data.apellido ? response.data.data.apellido : "",
            genero: response.data.data.id_genero ? response.data.data.id_genero : "",
            fechaNacimiento: response.data.data.fecha_nac ? parse(response.data.data.fecha_nac, 'dd/MM/yyyy', new Date()) : null,
            edadActual: response.data.data.edad ?? 0,
            eMail: response.data.data.email ? response.data.data.email : "",
            telefonoMovil: response.data.data.telefono_movil
              ? response.data.data.telefono_movil
              : "",
            telefonoFijo: response.data.data.telefono ? response.data.data.telefono : "",
            domicilio: response.data.data.domicilio ? response.data.data.domicilio : "",
            localidad: response.data.data.localidad ? response.data.data.localidad : "",
            departamento: response.data.data.id_departamento
              ? response.data.data.id_departamento
              : "",
            provincia: response.data.data.id_provincia ? response.data.data.id_provincia : "",
            pais: response.data.data.id_pais ? response.data.data.id_pais : "",
            codigoPostal: response.data.data.codigo_postal ? response.data.data.codigo_postal : "",
            actividad: response.data.data.list_cliente_actividad.map((item) => item.id),
            otraActividad: response.data.data.otra_actividad
              ? response.data.data.otra_actividad
              : "",
            ocupacion: response.data.data.list_cliente_ocupacion || [],
            otraOcupacion: response.data.data.otra_ocupacion
              ? response.data.data.otra_ocupacion
              : "",
          };
          setIsSetClient(true);
          setIsNewClient(false);
          setCliente(_cliente);
        } else {
          // si no existe el cliente
          setIsSetClient(true);
          setIsNewClient(true);
        }
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadCliente();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = (parCliente) => {
    setOpenDialogBusquedaAvanzada(false);

    if (!parCliente?.apellido) {
      setIsSetClient(false);
      return;
    }

    const clienteTmp = {
      id: parCliente.id ?? "",
      tipoDocumento: parCliente.id_tipo_documento ?? "",
      numeroDocumento: parCliente.num_doc ?? "",
      numeroCuitCuil: parCliente.cuit_cuil ?? "",
      nombre: parCliente.nombre ?? "",
      apellido: parCliente.apellido ?? "",
      genero: parCliente.id_genero ?? "",
      fechaNacimiento: parCliente.fecha_nac ? parse(parCliente.fecha_nac, 'dd/MM/yyyy', new Date()) : null,
      edadActual: parCliente.edad ?? 0,
      eMail: parCliente.email ?? "",
      telefonoMovil: parCliente.telefono_movil ?? "",
      telefonoFijo: parCliente.telefono ?? "",
      domicilio: parCliente.domicilio ?? "",
      localidad: parCliente.localidad ?? "",
      departamento: parCliente.id_departamento ?? "",
      provincia: parCliente.id_provincia ?? "",
      pais: parCliente.id_pais ?? "",
      codigoPostal: parCliente.codigo_postal ?? "",
      actividad: parCliente.list_cliente_actividad ?? [],
      otraActividad: parCliente.otra_actividad ?? "",
      ocupacion: parCliente.list_cliente_ocupacion ?? [],
      otraOcupacion: parCliente.otra_ocupacion ?? "",
    };
    setCliente(clienteTmp);
    setIsSetClient(true);
  };
  //
  // ################################################################################
  //
  const handleClickOpenCambiarDocumento = () => {
    setOpenDialogCambiarDocumento(true);
  };
  //
  // ################################################################################
  //
  const handleCloseCambiarDocumento = () => {
    setOpenDialogCambiarDocumento(false);
  };
  //
  // ################################################################################
  //
  const handleReloadTiposDocumentos = () => {
    loadTiposDocumentos();
  };
  //
  // ################################################################################
  //
  const handleReloadGeneros = () => {
    loadGeneros();
  };
  //
  // ################################################################################
  //
  const handleReloadDepartamentos = () => {
    loadDepartamentos();
  };
  //
  // ################################################################################
  //
  const handleReloadProvincias = () => {
    loadProvincias();
  };
  //
  // ################################################################################
  //
  const handleReloadPaises = () => {
    loadPaises();
  };
  //
  // ################################################################################
  //
  const handleReloadActividades = () => {
    loadActividades();
  };
  //
  // ################################################################################
  //
  const handleReloadOcupaciones = () => {
    loadOcupaciones();
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // opcional, evita submit de form
      e.preventDefault();
      buscarCliente();
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={3} sx={{ m: 1, p: 2 }}>
        <Box sx={{ m: 2, mb: 4 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={6} lg={3}>
              <FormControl
                disabled={isSetClient || disabledCliente}
                sx={{ width: "100%" }}
              >
                <InputLabel id="tipo-documento-select-label">Tipo de Documento</InputLabel>
                <Select
                  labelId="tipo-documento-select-label"
                  id="tipo-documento-select"
                  name="tipoDocumento"
                  value={tiposDocumentos.length > 0 ? tipoDocumento : ""}
                  label="Tipo de documento"
                  size="small"
                  onChange={handleChangeCliente}
                  autoFocus
                  input={
                    <OutlinedInput
                      label="Seleccionar"
                      endAdornment={
                        <InputAdornment position="end" sx={{ mr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadTiposDocumentos();
                            }}
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {tiposDocumentos.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 8
                }}
                id="numero-documento"
                label="Número"
                variant="outlined"
                size="small"
                disabled={isSetClient || disabledCliente}
                name="numeroDocumento"
                value={numeroDocumento}
                onChange={handleChangeCliente}
                onKeyDown={handleKeyDown}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              {gaAction.cu === "new" && (
                <>
                  <Tooltip title="buscar">
                    <span>
                      <Fab
                        sx={{ ml: 1, mr: 1 }}
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={buscarCliente}
                        disabled={isSetClient || disabledCliente}
                      >
                        <SearchIcon />
                      </Fab>
                    </span>
                  </Tooltip>

                  {gaAction.cu === "new" && (
                    <>
                      <Tooltip title="buscar clientes">
                        <span>
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="primary"
                            aria-label="add"
                            size="small"
                            onClick={handleClickOpenBusquedaAvanzada}
                            disabled={isSetClient || disabledCliente}
                          >
                            <ZoomInOutlinedIcon />
                          </Fab>
                        </span>
                      </Tooltip>

                      <Tooltip title="limpiar">
                        <span>
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="outlined"
                            aria-label="add"
                            size="small"
                            onClick={limpiaGA}
                            disabled={!isSetClient || disabledCliente}
                          >
                            <CleaningServicesIcon />
                          </Fab>
                        </span>
                      </Tooltip>

                      <Tooltip title="cambiar número de documento">
                        <span>
                          <Fab
                            sx={{ ml: 1, mr: 1 }}
                            color="outlined"
                            aria-label="add"
                            size="small"
                            onClick={handleClickOpenCambiarDocumento}
                            disabled={
                              !isSetClient || (isSetClient && isNewClient) || disabledCliente
                            }
                          >
                            <PublishedWithChangesOutlinedIcon />
                          </Fab>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ m: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off",
                  maxLength: 30
                }}
                id="nombre"
                label="Nombre"
                variant="outlined"
                size="small"
                name="nombre"
                value={nombre}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off",
                  maxLength: 30
                }}
                id="apellido"
                label="Apellido"
                variant="outlined"
                size="small"
                name="apellido"
                value={apellido}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={1.5}>
              <DatePicker
                sx={{
                  width: "100%",
                  mb: 1,
                  "& .MuiInputLabel-root": {
                    transform: "translate(14px, 9px) scale(1)",
                  },
                  "& .MuiInputBase-root": {
                    paddingRight: "10px",
                  },
                  "& .MuiInputLabel-shrink": {
                    transform: "translate(14px, -8px) scale(0.75)",
                  },
                }}
                id="fechaNacimiento"
                label="Fecha de Nacimiento"
                variant="outlined"
                name="fechaNacimiento"
                value={fechaNacimiento}
                format="dd/MM/yyyy"
                maxDate={new Date()}
                onChange={(newValue) =>
                  handleChangeClienteFechaNacimiento(newValue)
                }
                disabled={!isSetClient || disabledCliente}
                slots={{ textField: TextField }}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={0.5}>
              <TextField
                sx={{ width: "100%" }}
                id="
                      "
                label="Edad"
                variant="outlined"
                size="small"
                name="edad"
                value={edadActual}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={1.5}>
              <FormControl
                disabled={!isSetClient || disabledCliente}
                sx={{ width: "100%" }}
              >
                <InputLabel id="genero-select-label">Género</InputLabel>
                <Select
                  labelId="genero-select-label"
                  id="genero-select"
                  name="genero"
                  value={generos.length > 0 ? genero : ""}
                  label="Género"
                  size="small"
                  onChange={handleChangeCliente}
                  MenuProps={{ style: { maxHeight: "300px" } }}
                  input={
                    <OutlinedInput
                      label="Seleccionar"
                      endAdornment={
                        <InputAdornment position="end" sx={{ mr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadGeneros();
                            }}
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {generos.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={2.5}>
              <TextField
                sx={{ width: "100%" }}
                id="numero-cuit-cuil"
                label="CUIT/CUIL (sin guiones ni espacios)"
                variant="outlined"
                size="small"
                name="numeroCuitCuil"
                value={numeroCuitCuil}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 11
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ m: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 50
                }}
                id="eMail"
                label="E-Mail"
                variant="outlined"
                size="small"
                name="eMail"
                value={eMail}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 15
                }}
                id="telefonoMovil"
                label="Teléfono Móvil"
                variant="outlined"
                size="small"
                name="telefonoMovil"
                value={telefonoMovil}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 15
                }}
                id="telefonoFijo"
                label="Teléfono Fijo"
                variant="outlined"
                size="small"
                name="telefonoFijo"
                value={telefonoFijo}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ m: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 50
                }}
                id="domicilio"
                label="Domicilio"
                variant="outlined"
                size="small"
                name="domicilio"
                value={domicilio}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={2}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 30
                }}
                id="localidad"
                label="Localidad"
                variant="outlined"
                size="small"
                name="localidad"
                value={localidad}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={2}>
              <FormControl
                disabled={!isSetClient || disabledCliente}
                sx={{ width: "100%" }}
              >
                <InputLabel id="departamento-select-label">Departamento</InputLabel>
                <Select
                  labelId="departamento-select-label"
                  id="departamento-select"
                  name="departamento"
                  value={departamentos.length > 0 ? departamento : ""}
                  label="Departamento"
                  size="small"
                  onChange={handleChangeCliente}
                  MenuProps={{ style: { maxHeight: "300px" } }}
                  input={
                    <OutlinedInput
                      label="Seleccionar"
                      endAdornment={
                        <InputAdornment position="end" sx={{ mr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadDepartamentos();
                            }}
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {departamentos.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={2}>
              <FormControl
                disabled={!isSetClient || disabledCliente}
                sx={{ width: "100%" }}
              >
                <InputLabel id="provincia-select-label">Provincia</InputLabel>
                <Select
                  labelId="provincia-select-label"
                  id="provincia-select"
                  name="provincia"
                  value={provincias.length > 0 ? provincia : ""}
                  label="provincia"
                  size="small"
                  onChange={handleChangeCliente}
                  MenuProps={{ style: { maxHeight: "300px" } }}
                  input={
                    <OutlinedInput
                      label="Seleccionar"
                      endAdornment={
                        <InputAdornment position="end" sx={{ mr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadProvincias();
                            }}
                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {provincias.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={2}>
              <FormControl
                disabled={!isSetClient || disabledCliente}
                sx={{ width: "100%", mb: 1 }}
              >
                <InputLabel id="pais-select-label">País</InputLabel>
                <Select
                  labelId="pais-select-label"
                  id="pais-select"
                  name="pais"
                  value={paises.length > 0 ? pais : ""}
                  label="pais"
                  size="small"
                  onChange={handleChangeCliente}
                  MenuProps={{ style: { maxHeight: "300px" } }}
                  input={
                    <OutlinedInput
                      label="Seleccionar"
                      endAdornment={
                        <InputAdornment position="end" sx={{ mr: 2 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              loadPaises();
                            }}

                            onMouseDown={(e) => e.stopPropagation()}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  }
                >
                  {paises.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={1}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 8
                }}
                id="codigoPostal"
                label="Código Postal"
                variant="outlined"
                size="small"
                name="codigoPostal"
                value={codigoPostal}
                onChange={handleChangeCliente}
                disabled={!isSetClient || disabledCliente}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>

      {/* >>>> Diálogo de búsqueda de Clientes */}

      {openDialogBusquedaAvanzada && (
        <BuscarClienteDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
          canCreateEdit={false}
        />
      )}

      {/* >>>> Diálogo de cambiar documento */}

      {openDialogCambiarDocumento && (
        <CambiarDocumentoDialog
          open={openDialogCambiarDocumento}
          onClose={handleCloseCambiarDocumento}
          idCliente={id}
          tipoDocumentoActual={tipoDocumento}
          numeroDocumentoActual={numeroDocumento}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Cliente;
